module.exports = __webpack_public_path__ + "prod/1.42.2/img/banner.4370b24c.png";